import LeaderboardBudgetSelector from './LeaderboardBudgetSelector';

export default LeaderboardBudgetSelector;
